import { useState } from "react";

export type BillViewMode = "card" | "table";

const STORAGE_KEY = "billme_last_bill_view_mode";
const DEFAULT_MODE: BillViewMode = "card";

function readStoredMode(): BillViewMode {
	const stored = localStorage.getItem(STORAGE_KEY);
	return stored === "table" ? "table" : DEFAULT_MODE;
}

// Remembers the last view mode a user picked on the bill list so repeat
// visits default to it instead of always resetting to card view — same
// pattern as useLastPrintSize.
export function useLastBillViewMode(): [BillViewMode, (mode: BillViewMode) => void] {
	const [mode, setModeState] = useState<BillViewMode>(readStoredMode);

	const setMode = (next: BillViewMode) => {
		setModeState(next);
		localStorage.setItem(STORAGE_KEY, next);
	};

	return [mode, setMode];
}
